import React, { useEffect, useRef, useState, useContext } from "react";
import { TbClockHour7, TbPlayerPlay, TbDots } from "react-icons/tb";
import "./KronosBox.css";
import { useLanguage } from "../../../../LanguageProvider";
import { GeneralContext } from "../../../../GeneralProvider";
import TaskManagement from "../../../TaskManagementPage/TaskManagement";
export default function KronosBox({
  box,
  index,
  handlePlay,
  handleDelete,
  handleEdit,
  groups,
  moveToGroup,
  type,
  openModal,
  activeKronos
}) {
  const { setSelectedTaskByKronos, openedWindows } = useContext(GeneralContext);
  const { getTranslation } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const [groupMenuOpen, setGroupMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef(null);

  const formatTimestamp = (timestamp) => {
    const date = new Date(parseInt(timestamp, 10) * 1000);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    });
  };

  const monthNames = [
    getTranslation("january"),
    getTranslation("february"),
    getTranslation("march"),
    getTranslation("april"),
    getTranslation("may"),
    getTranslation("june"),
    getTranslation("july"),
    getTranslation("august"),
    getTranslation("september"),
    getTranslation("october"),
    getTranslation("november"),
    getTranslation("december"),
  ];

  function formatLocalizedDate(timestamp) {
    const date = new Date(parseInt(timestamp, 10) * 1000);
    const day = date.getDate();
    const monthIndex = date.getMonth(); // 0-11 arasında bir değer döner
    const year = date.getFullYear();

    // Localization dosyasından çeviriyi bulan hazır array
    const monthName = monthNames[monthIndex] || monthNames[0]; // Eğer çeviri eksikse Ocak'ı koy

    return `${day} ${monthName} ${year}`;
  }

  const calculateDuration = (start, end) => {
    const durationInSeconds = parseInt(end, 10) - parseInt(start, 10);
    if (durationInSeconds < 60) return "00:00";

    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);

    const formattedHours = hours > 0 ? String(hours).padStart(2, "0") : "00";
    const formattedMinutes = String(minutes).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}`;
  };

  const handleMenuToggle = (event) => {
    setGroupMenuOpen(false); // Alt menüyü kapat
    const buttonRect = event.target.getBoundingClientRect();
    setMenuPosition({
      top: buttonRect.bottom + window.scrollY,
      left: buttonRect.left + window.scrollX,
    });
    setMenuOpen((prev) => !prev);
  };

  const handleScroll = () => {
    // Liste kaydırıldığında menüyü kapat
    setMenuOpen(false);
    setGroupMenuOpen(false);
  };

  const handleViewTask = () => {
    setSelectedTaskByKronos(box?.taskId);
    openModal("taskManagement");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
        setGroupMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  if (box.endDateTime) {
    return (
      <div className="kronos-box">
        <span className="kronos-box-title">{box.title}</span>
        {/* <span>{box.title}</span> */}
        <div key={box.logId}>
          <div className="kronos-inner-box-container">
            {type === "view" && (
              <>
                <div
                  className="kronos-inner-box-with-times"
                  style={{ width: "auto" }}
                >
                  <div className="kronos-inner-box-with-times-holder">
                    <span>{formatLocalizedDate(box.startDateTime)}</span>
                  </div>
                </div>
                <div
                  className="kronos-inner-box-with-times"
                  style={{ width: "auto" }}
                >
                  <div className="kronos-inner-box-with-times-holder">
                    <span>{formatLocalizedDate(box.endDateTime)}</span>
                  </div>
                </div>
              </>
            )}
            {box?.taskId?.length > 1 && (
              <span onClick={handleViewTask} className="kronos-view-task">
                {getTranslation("viewTask")}
              </span>
            )}

            {box?.subProjectTitle && (
              <span className="task-detail-modal-sub-project">
                {box?.subProjectTitle}
              </span>
            )}

            <div className="kronos-inner-box-with-times">
              <TbClockHour7 size={18} />
              <div className="kronos-inner-box-with-times-holder">
                <span>{formatTimestamp(box.startDateTime)}</span>
                <span>{formatTimestamp(box.endDateTime)}</span>
              </div>
            </div>
            <div className="kronos-inner-box">
              <span>{calculateDuration(box.startDateTime, box.endDateTime)}</span>
            </div>
            {!activeKronos &&
              <>
                {type !== "view" && (
                  <>
                    <div
                      className="kronos-inner-box kronos-inner-box-button"
                      onClick={() => handlePlay(box.kronosId, box.title)}
                    >
                      <span>
                        <TbPlayerPlay size={18} style={{ marginTop: "2px" }} />
                      </span>
                    </div>

                    <div className="kronos-inner-box kronos-inner-box-button" onClick={handleMenuToggle}>
                      <span>
                        <TbDots size={18} style={{ marginTop: "2px" }} />
                      </span>
                    </div>
                  </>
                )}
              </>
            }

          </div>
          {menuOpen ? (
            <div
              className="kronos-dropdown-menu"
              ref={menuRef}
              style={{
                top: `${menuPosition.top}px`,
                left: `${menuPosition.left}px`,
                position: "fixed",
              }}
            >
              <>
                <div
                  className="kronos-menu-item"
                  onClick={() => {
                    handleEdit({
                      title: box.title,
                      startDateTime: box.startDateTime,
                      endDateTime: box.endDateTime,
                      kronosId: box.kronosId,
                      logId: box.logId,
                    });
                    setMenuOpen(false);
                  }}
                >
                  {getTranslation("edit")}
                </div>
                <div
                  className="kronos-menu-item"
                  onClick={() => {
                    setGroupMenuOpen(true);
                    setMenuOpen(false);
                  }} // Tıklama ile açma/kapama
                >
                  {getTranslation("moveToGroup")}
                </div>
                <div
                  className="kronos-menu-item"
                  onClick={() => {
                    handleDelete(box.logId);
                    setMenuOpen(false);
                  }}
                >
                  {getTranslation("delete")}
                </div>
              </>
            </div>
          ) : groupMenuOpen ? (
            <div
              className="kronos-dropdown-menu"
              ref={menuRef}
              style={{
                top: `${menuPosition.top}px`,
                left: `${menuPosition.left}px`,
                position: "fixed",
              }}
            >
              <div
                className="kronos-menu-item"
                onClick={() => {
                  setGroupMenuOpen(false);
                  setMenuOpen(true);
                }}
              >
                {getTranslation("back")}
              </div>
              {groups.map((group) => (
                <div
                  className="kronos-menu-item"
                  key={group.value}
                  onClick={() => {
                    moveToGroup(group.value, box.kronosId);
                    setGroupMenuOpen(false);
                    setMenuOpen(false);
                  }}
                >
                  {group?.value === "empty"
                    ? getTranslation("ungroup")
                    : group.label}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  else {
    return null;
  }
}
